// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policy-chapters,
.policy-sub-chapters,
.policy-toc {
  counter-reset: item;
}

.policy-chapter,
.policy-sub-chapter,
.policy-toc-item {
  counter-increment: item;
}

.policy-chapter-title::before,
.policy-sub-chapter-title::before,
.policy-toc-link:before {
  content: counters(item, '.');
  display: inline-block;
  margin-right: 8px;
}

.policy-sub-chapter--no-title *:first-child:before {
  content: counters(item, '.');
  display: inline-block;
  margin-right: 8px;
}

.policy-body p,
.policy-content p,
.policy-chapter p,
.policy-sub-chapter p {
  margin-bottom: 24px;
}

.policy-chapter ul,
.policy-sub-chapter ul {
  margin: 0 0 24px 24px;
  list-style-type: square;
}

.policy-chapter ul ul,
.policy-sub-chapter ul ul {
  list-style-type: none;
}

.policy-chapter ul ul li:before,
.policy-sub-chapter ul ul li:before {
  content: '-';
  width: 16px;
  display: inline-block;
}

.cookie-table {
  border-spacing: 0;
  border-collapse: separate;
  word-break: break-word;
}

.cookie-table th {
  border-right: 1px solid #d7d7d7;
  min-width: 65px;
  max-width: 300px;
  background-color: #f8f8f8;
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #d7d7d7;
}

.cookie-table tr th:first-child {
  border-top-left-radius: 5px;
}

.cookie-table tr th:last-child {
  border-top-right-radius: 5px;
}

.group-end td {
  border-bottom: 1px solid #d7d7d7 !important;
}

.cookie-table td {
  padding: 2px 6px 2px 10px;
  border-right: 1px solid #d7d7d7;
}

.cookie-table tr:last-child td {
  border-bottom: 0;
}

.cookie-table tr th:last-child,
td:last-child {
  border-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/policy/PolicyPage.css"],"names":[],"mappings":"AAAA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB","sourcesContent":[".policy-chapters,\n.policy-sub-chapters,\n.policy-toc {\n  counter-reset: item;\n}\n\n.policy-chapter,\n.policy-sub-chapter,\n.policy-toc-item {\n  counter-increment: item;\n}\n\n.policy-chapter-title::before,\n.policy-sub-chapter-title::before,\n.policy-toc-link:before {\n  content: counters(item, '.');\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.policy-sub-chapter--no-title *:first-child:before {\n  content: counters(item, '.');\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.policy-body p,\n.policy-content p,\n.policy-chapter p,\n.policy-sub-chapter p {\n  margin-bottom: 24px;\n}\n\n.policy-chapter ul,\n.policy-sub-chapter ul {\n  margin: 0 0 24px 24px;\n  list-style-type: square;\n}\n\n.policy-chapter ul ul,\n.policy-sub-chapter ul ul {\n  list-style-type: none;\n}\n\n.policy-chapter ul ul li:before,\n.policy-sub-chapter ul ul li:before {\n  content: '-';\n  width: 16px;\n  display: inline-block;\n}\n\n.cookie-table {\n  border-spacing: 0;\n  border-collapse: separate;\n  word-break: break-word;\n}\n\n.cookie-table th {\n  border-right: 1px solid #d7d7d7;\n  min-width: 65px;\n  max-width: 300px;\n  background-color: #f8f8f8;\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #d7d7d7;\n}\n\n.cookie-table tr th:first-child {\n  border-top-left-radius: 5px;\n}\n\n.cookie-table tr th:last-child {\n  border-top-right-radius: 5px;\n}\n\n.group-end td {\n  border-bottom: 1px solid #d7d7d7 !important;\n}\n\n.cookie-table td {\n  padding: 2px 6px 2px 10px;\n  border-right: 1px solid #d7d7d7;\n}\n\n.cookie-table tr:last-child td {\n  border-bottom: 0;\n}\n\n.cookie-table tr th:last-child,\ntd:last-child {\n  border-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
